export default "__VITE_ASSET__BwkvzoVB__"